export default __webpack_public_path__ + "static/media/escape.2ac21080.png";